import { Link } from "react-router-dom";
import type { ChangeAuditSource } from "@/api/changeAudit.service";
import { AUDIT_READ_PERMISSION } from "@/constants/permissions";
import { usePermissions } from "@/hooks/usePermissions";
import { ROUTES } from "@/routes";
import styles from "./ChangeHistoryLink.module.css";

export function changeHistoryPath(source: ChangeAuditSource, entityId: string): string {
  const params = new URLSearchParams({ log: source, entityId });
  return `${ROUTES.research.auditLog}?${params.toString()}`;
}

/** Opens the audit log filtered to one record; hidden from people who cannot read the log. */
export function ChangeHistoryLink({
  source,
  entityId,
}: {
  source: ChangeAuditSource;
  entityId: string;
}) {
  const { hasPermission } = usePermissions();
  if (!hasPermission(AUDIT_READ_PERMISSION)) return null;

  return (
    <Link to={changeHistoryPath(source, entityId)} className={styles.link}>
      Change history
    </Link>
  );
}
